import { useEffect } from 'react'

export const SITE_URL = 'https://www.gregchui.com'

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]')
  if (!href) {
    if (el) el.remove()
    return
  }
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', 'canonical')
    document.head.appendChild(el)
  }
  el.setAttribute('href', href)
}

// Per-page title, description, canonical URL and social tags. The prerender step
// (scripts/prerender.mjs) bakes these into each page's static HTML.
const usePageMeta = ({ title, description, path, noindex = false }) => {
  useEffect(() => {
    const url = path ? SITE_URL + path : null

    document.title = title
    setMeta('name', 'title', title)
    setMeta('name', 'description', description)
    setMeta('property', 'og:title', title)
    setMeta('property', 'og:description', description)
    setMeta('property', 'twitter:title', title)
    setMeta('property', 'twitter:description', description)
    if (url) {
      setMeta('property', 'og:url', url)
      setMeta('property', 'twitter:url', url)
    }
    setMeta('name', 'robots', noindex ? 'noindex' : 'all')
    setMeta('name', 'googlebot', noindex ? 'noindex' : 'index, follow')
    setCanonical(noindex ? null : url)
  }, [title, description, path, noindex])
}

export default usePageMeta
